import csatGuard from './guards/csatGuard';
import jwtGuard from './guards/jwt.guard';
import originGuard from './guards/originGuard';
import pageReloadGuard from './guards/pageReloadGuard';
import selectUnitGuard from './guards/selectUnitGuard';
import pageConclusionCheckinGuard from './guards/pageConclusionCheckinGuard';
import dynatracePageIdentifierGuard from './guards/dynatracePageIdentifierGuard';
import redirectToMFGuard from './guards/redirectToMFGuard';

const guards = [
  csatGuard,
  jwtGuard,
  originGuard,
  redirectToMFGuard,
  pageReloadGuard,
  selectUnitGuard,
  pageConclusionCheckinGuard,
  dynatracePageIdentifierGuard,
];

export default guards;
